import React from 'react';
import styled, { css } from 'styled-components';
import Loading from '../../components/loading/Loading';
import LoadingLogo from '../../components/loading/LoadingLogo';
import { hasCompletedInitialLoad } from '../../components/loading/hasCompletedInitialLoad';

const LoadingContainer = styled.div<{ $fullViewport: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 0;

  ${({ $fullViewport }) => $fullViewport && css`
    min-height: 100vh;
    min-height: 100dvh;
  `}
`;

interface RouteLoadingFallbackProps {
  fullViewport?: boolean;
}

const RouteLoadingFallback: React.FC<RouteLoadingFallbackProps> = ({
  fullViewport = false,
}) => {
  const LoadingComponent = hasCompletedInitialLoad.current ? Loading : LoadingLogo;

  return (
    <LoadingContainer $fullViewport={fullViewport}>
      <LoadingComponent contained />
    </LoadingContainer>
  );
};

export default RouteLoadingFallback;
